import { ContentType, UrlParser } from "@authory-packages/core";
import { getSlug } from "../utils/getSlug";

export const pickSuggestedSource = (
    contentType: ContentType,
    url: string | null | undefined,
    sourcesOptions: { value: string; text: string | null; url: string }[]
) => {
    const isPDF = contentType === ContentType.PdfFile;
    const isWebsite = contentType === ContentType.Website;
    const isEmail = contentType === ContentType.Email;
    const isArticle = contentType === ContentType.Article;
    const dontSuggestSourceTypes = isPDF || isWebsite || isEmail;

    // for these cases, we don't have a suggestion and we allow the user to create a new source
    if (dontSuggestSourceTypes || !url)
        return { existingSourceSuggestion: "", allowCreateNewSource: true, newSource: false, newSourceNameSuggestion: "" };

    // For article, we only allow create a new source if we dont already match a slug
    if (isArticle) {
        try {
            const domain = UrlParser.extractDomain(url) || "";
            const urlSlug = getSlug(url);
            const srcMatch = sourcesOptions.find((opt) => getSlug(opt.url) === urlSlug);
            // if there is a match, we don't allow creating new source as that would trigger api error
            if (srcMatch) {
                return { existingSourceSuggestion: srcMatch.value, allowCreateNewSource: false, newSource: false, newSourceNameSuggestion: "" };
            }

            // no match means user can create a new source
            return { existingSourceSuggestion: "", allowCreateNewSource: true, newSource: true, newSourceNameSuggestion: domain };
        } catch {}
    }

    // catch-all
    return { existingSourceSuggestion: "", allowCreateNewSource: true, newSource: false, newSourceNameSuggestion: "" };
};
